import React from "react";
import { Grid, Typography, Paper } from "@material-ui/core";
import JsonRenderComponent from "../../../utils/JsonRenderComponent";
import { COLORS } from "../styles/theme";

interface ResponseDisplayProps {
  title: string;
  subtitle?: string;
  data: any;
  color: string;
  icon: string | React.ReactNode;
  forwardRef?: React.RefObject<HTMLDivElement>;
}

const ResponseDisplay: React.FC<ResponseDisplayProps> = ({
  title,
  subtitle,
  data,
  color,
  icon,
  forwardRef,
}) => {
  return (
    <Grid item xs={12} style={{ width: "100%" }}>
      <Paper
        ref={forwardRef}
        elevation={2}
        style={{
          width: "100%",
          marginTop: 32,
          padding: 24,
          borderRadius: 8,
          borderLeft: `6px solid ${color}`,
          backgroundColor: COLORS.white,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: 16,
          }}
        >
          <div
            style={{
              backgroundColor: color,
              borderRadius: "50%",
              width: 40,
              height: 40,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: 16,
            }}
          >
            <Typography
              style={{
                color: COLORS.white,
                fontSize: 20,
                fontWeight: "bold",
              }}
            >
              {icon}
            </Typography>
          </div>
          <div>
            <Typography
              variant="h6"
              style={{
                color: COLORS.textPrimary,
                fontWeight: 600,
                marginBottom: 4,
              }}
            >
              {title}
            </Typography>
            {subtitle && (
              <Typography variant="caption" color="textSecondary">
                {subtitle}
              </Typography>
            )}
          </div>
        </div>
        <Paper
          elevation={0}
          style={{
            padding: 20,
            whiteSpace: "pre-wrap",
            wordBreak: "break-all",
            wordWrap: "break-word",
            overflowWrap: "break-word",
            overflow: "auto",
            maxHeight: 500,
            backgroundColor: COLORS.bgLight,
            borderRadius: 8,
            border: `1px solid ${COLORS.gray200}`,
          }}
        >
          <JsonRenderComponent jsonObject={data} printHtml={false} />
        </Paper>
      </Paper>
    </Grid>
  );
};

export default ResponseDisplay;
